import { render, staticRenderFns } from "./ServerCollect.vue?vue&type=template&id=5abd3eee&scoped=true&"
import script from "./ServerCollect.vue?vue&type=script&lang=js&"
export * from "./ServerCollect.vue?vue&type=script&lang=js&"
import style0 from "./ServerCollect.vue?vue&type=style&index=0&id=5abd3eee&scoped=true&lang=css&"
import style1 from "./ServerCollect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd3eee",
  null
  
)

export default component.exports